// React
import React, { useState } from 'react';

// Components & Hooks
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

// Utils
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { keyEmptyCheck } from 'aurora-utils/utils';
import withStyles from '@material-ui/core/styles/withStyles';

// Local Components Import
import DocumentsView from './DocumentsView';
import DocumentsUpload from './DocumentsUpload';

// Styles
import styles from './styles';

function DocumentsMain(props) {
  const {
    classes,
    applicationId,
    attributes,
    applicationType,
    isCustomSubType,
    documents,
    handleUploadDoc,
    handleDeleteDoc,
    handleDocDownload,
    handleDownloadAllDocs,
    isEditable = false,
    title,
    showTitle,
    hideDownloadAllBtn,
    extraHeaderComp,
    viewDocumentButtonText,
    isHandlePreview,
    hideInfoBox,
  } = props;

  if (!isEditable && isEmpty(documents)) return null;
  const [errorAttribute, setErrorAttribute] = useState({ id: '', error: '' });
  // Handling upload file
  const handleUpload = (e, isMultiple, attrId) => {
    const { name, files, dataset } = e.target;

    if (files[0]) {
      const fileIndex = crypto.randomUUID();
      const params = {
        applicationId,
        applicationType,
        documentType: name,
        subType: isMultiple
          ? `APPLICATION_${applicationId}.${name}_${fileIndex}`
          : isCustomSubType || `APPLICATION_${applicationId}.${name}`,
        ...(dataset?.userId && { userId: dataset?.userId }),
        ...(dataset?.customerId && { customerId: dataset?.customerId }),
        ...(dataset?.companyId && { companyId: dataset?.companyId }),
      };
      const { size } = files[0];
      if (size > 20971520) {
        setErrorAttribute({
          id: attrId,
          error: 'max_doc_size',
        });
        return;
      }
      setErrorAttribute({ id: '', error: '' });
      const formData = new FormData();

      formData.append('file', files[0]);

      handleUploadDoc && handleUploadDoc(formData, params);
    }
  };

  const handleViewFile = (name, subType, fileName, extras) => {
    const payload = {
      applicationId: applicationId || extras.applicationId,
      applicationType,
      documentType: name,
      subType,
      fileName,
    };

    handleDocDownload && handleDocDownload(payload, extras);
  };

  // It needs to be ehanced as per backend in future
  const handleDownloadAllFiles = () => {
    const payload = {
      applicationId,
      applicationType,
    };
    handleDownloadAllDocs && handleDownloadAllDocs(payload);
  };

  const handleFileRemove = file => {
    handleDeleteDoc && handleDeleteDoc(file);
  };
  return (
    <div key={applicationId} className={classes.docContainer}>
      <Box
        display={extraHeaderComp && 'flex'}
        flexDirection={{ xs: 'column', md: 'row' }}
        justifyContent='space-between'
        alignItems='center'
      >
        {showTitle && (
          <Typography component='h6' className={classes.docHeading}>
            {title ? keyEmptyCheck(title) : keyEmptyCheck('application_documents_lowerCase')}
          </Typography>
        )}
        {extraHeaderComp && extraHeaderComp}
      </Box>

      {isEditable ? (
        <DocumentsUpload
          classes={classes}
          attributes={attributes}
          documents={documents}
          handleUpload={handleUpload}
          handleFileRemove={handleFileRemove}
          errorAttribute={errorAttribute}
          hideInfoBox={hideInfoBox}
        />
      ) : (
        <DocumentsView
          classes={classes}
          attributes={attributes}
          applicationType={applicationType}
          applicationId={applicationId}
          isHandlePreview={isHandlePreview}
          documents={documents}
          handleViewFile={handleViewFile}
          handleDownloadAllDocs={handleDownloadAllFiles}
          hideDownloadAllBtn={hideDownloadAllBtn}
          viewDocumentButtonText={viewDocumentButtonText}
        />
      )}
    </div>
  );
}

DocumentsMain.propTypes = {
  classes: PropTypes.object.isRequired,
  applicationId: PropTypes.string.isRequired,
  applicationType: PropTypes.string.isRequired,
  isCustomSubType: PropTypes.string,
  documents: PropTypes.array.isRequired,
  handleDeleteDoc: PropTypes.func.isRequired,
  handleUploadDoc: PropTypes.func.isRequired,
  handleDocDownload: PropTypes.func.isRequired,
  handleDownloadAllDocs: PropTypes.func,
  isEditable: PropTypes.bool.isRequired,
  attributes: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  showTitle: PropTypes.bool,
  hideDownloadAllBtn: PropTypes.bool,
  extraHeaderComp: PropTypes.node,
  viewDocumentButtonText: PropTypes.string,
  isHandlePreview: PropTypes.bool,
  hideInfoBox: PropTypes.bool,
};

DocumentsMain.defaultProps = {
  handleDownloadAllDocs: () => {},
  hideDownloadAllBtn: false,
  extraHeaderComp: null,
  viewDocumentButtonText: 'view',
  isHandlePreview: true,
  isCustomSubType: '',
  showTitle: true,
  hideInfoBox: false,
};

export default withStyles(styles)(DocumentsMain);
